/* eslint-disable complexity */
import cn from "classnames"
import React from "react"
import { useTranslation } from "react-i18next"

import { Event } from "~/api/types/Event"
import { Button, ButtonLink } from "~/components/Button/Button"
import { Card } from "~/components/Card/Card"
import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"
import { formatDateNew, isOnlyDate } from "~/helpers/formatDate"
import { getGoogleCalendarLink } from "~/helpers/getGoogleCalendarLink"

import { Raw } from "../raw"
import styles from "./index.module.css"

export const EventCard: React.FC<Event & { displayActivity?: boolean }> = ({
  date,
  linkBefore,
  linkAfter,
  descriptionBefore,
  descriptionAfter,
  name,
  city,
  status,
  linkButton,
  code,
  previously,
  displayActivity,
}) => {
  const { t } = useTranslation()

  return (
    <Card
      className={cn(styles.Wrapper, { [styles.Closed]: status === "closed" && displayActivity })}
      heading={city}
      link={`/investors-and-shareholders/calendar/${code}`}
    >
      <div className={styles.Data}>
        <Heading className={styles.Date} like="h3">
          {status === "active" && (
            <>
              {isOnlyDate(date)
                ? formatDateNew(date, "d MMMM yyyy")
                : formatDateNew(date, "d MMMM, HH:mm")}
            </>
          )}

          {status === "closed" && <>{formatDateNew(date, "d MMMM yyyy")}</>}

          {previously && status === "active" && <Raw html={t("event.Previously")} />}
        </Heading>

        <div>{name}</div>

        {linkBefore && status === "active" && (
          <div className={styles.Site}>
            <Link href={linkBefore} target="_blank" view="arrow">
              {descriptionBefore}
            </Link>
          </div>
        )}

        {linkAfter && status === "closed" && (
          <div className={styles.Site}>
            <Link href={linkAfter} target="_blank" view="arrow">
              {descriptionAfter}
            </Link>
          </div>
        )}
      </div>

      {status === "active" && (
        <div className={styles.Buttons}>
          {linkButton && (
            <ButtonLink className={styles.Button} href={linkButton} target="_blank" view="rounded">
              <Raw html={t("event.Buttons.Appointment")} />
            </ButtonLink>
          )}

          <Button
            className={styles.Button}
            view="rounded"
            onClick={() => getGoogleCalendarLink(city, name, date, linkBefore)}
          >
            <Raw html={t("event.Buttons.AddToCalendar")} />
          </Button>
        </div>
      )}
    </Card>
  )
}
